import React from 'react';
import { sendToMessageWhatsApp } from '../../../utils/callToWhatsApp';
import { Icon } from '../../Icons';
import { Ripple } from '../../Ripple';

interface SendToWhatsAppProps {
  message: string;
  numberPhone: string;
}
interface Props {
  sendToWhatsApp: SendToWhatsAppProps;
}
export const WhatsAppShared = ({ sendToWhatsApp }: Props) => {
  const { numberPhone, message } = sendToWhatsApp;
  return (
    <Ripple>
      <li className="pt16 pb16 b--alto bb pointer hover-bg-wild-sand">
        <a
          href={sendToMessageWhatsApp(numberPhone, message)}
          className="flex items-center f14 fw4 abbey no-underline"
          title="WhatsApp"
        >
          <Icon name="SvgIconWhatsapp" className="mr4" height={24} width={24} />
          WhatsApp
        </a>
      </li>
    </Ripple>
  );
};
